import{m as u}from"./chunk-HBP5N4FR.js";u();var b=({accountNonce:r,transactionNonce:e})=>e&&e>r?e:r;export{b as a};
//# sourceMappingURL=chunk-VVY3H3F7.js.map
